// extracted by mini-css-extract-plugin
module.exports = {"training_path_pagination":"components_training_path_pagination__31-wK","cancel":"components_cancel__arx1y","submit":"components_submit__2_j0-"};